import { render } from "./WorkAreaTableRow.vue?vue&type=template&id=71b480fa"
import script from "./WorkAreaTableRow.vue?vue&type=script&lang=ts"
export * from "./WorkAreaTableRow.vue?vue&type=script&lang=ts"
script.render = render

export default script